'use client';
import { isFunction } from '@s7/utils';
import { useNodeOverridableTheme } from '../../theming/propagation/ThemeProvider.js';
import { filterProps } from './filterProps/filterProps.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/*
 * Предназначен для получения конечного набора свойств компонента,
 * на основе которого формируется его представление.
 * Хук получает из темы contextProps - defaultProps конкретного компонента.
 * - contextProps - перекрывают defaultProps;
 * - props - перекрывают contextProps и defaultProps;
 * - localContext - перекрывают все вышеперечисленные, предназначено для использования
 * в compound-компонентах, где дочерние компоненты используют контекст родительского.
 * */ function useComponentDefaultProps(component, defaultProps, props, localContext) {
    var _theme_components_component, _theme_components;
    var theme = useNodeOverridableTheme(props == null ? void 0 : props.theme);
    var componentThemeDefaultProps = (_theme_components = theme.components) == null ? void 0 : (_theme_components_component = _theme_components[component]) == null ? void 0 : _theme_components_component.defaultProps;
    var themeOverrideContextProps = isFunction(componentThemeDefaultProps) ? componentThemeDefaultProps(theme) : componentThemeDefaultProps;
    var localProps = (localContext == null ? void 0 : localContext.context) ? filterProps(localContext.context, localContext.exclude) : {};
    return _extends({}, defaultProps, themeOverrideContextProps, filterProps(props), localProps);
}

export { useComponentDefaultProps };
